(function(){
  'use strict';
  document.documentElement.classList.add('js');
  const $=(s,root=document)=>root.querySelector(s);
  const $$=(s,root=document)=>Array.from(root.querySelectorAll(s));
  const config=window.SHAVERA_CONFIG||{};
  const number=String(config.whatsappNumber||'').replace(/\D/g,'');
  const backupNumber=String(config.whatsappBackupNumber||number).replace(/\D/g,'');
  const connected=/^[1-9]\d{6,14}$/.test(number)&&number!=='15555550100';
  const defaultMessage="Hi SHAVERA, I'd love to discuss a piece of jewelry made for me.";
  const waUrl=(message,recipient=number)=>'https://wa.me/'+recipient+'?text='+encodeURIComponent(message);
  let returnFocus=null;
  const cartCounts=$$('[data-cart-count]');
  const cartFloats=$$('[data-cart-float]');
  const setCartCount=n=>{cartCounts.forEach(el=>{el.textContent=String(n);});cartFloats.forEach(el=>{el.classList.toggle('has-items',n>0);el.setAttribute('aria-label','View your cart, '+n+' item'+(n===1?'':'s'));});};
  const refreshCartCount=()=>fetch('/cart.js').then(r=>r.ok?r.json():Promise.reject()).then(c=>setCartCount(c.item_count)).catch(()=>{});
  function addVariantToCart(id,btn){
    if(!id)return;
    const label=btn.textContent;btn.disabled=true;btn.setAttribute('aria-busy','true');btn.textContent='Adding…';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({items:[{id:Number(id),quantity:1}]})})
      .then(r=>{if(!r.ok)throw new Error();return refreshCartCount();})
      .then(()=>{btn.textContent='Added';setTimeout(()=>{btn.textContent=label;btn.disabled=false;btn.removeAttribute('aria-busy');},1400);})
      .catch(()=>{window.location.assign('/cart/'+id+':1');});
  }
  $$('[data-add-to-cart]').forEach(btn=>btn.addEventListener('click',e=>{e.preventDefault();addVariantToCart(btn.dataset.variantId,btn);}));
  refreshCartCount();
  function openDialog(dialog){
    returnFocus=document.activeElement;
    if(typeof dialog.showModal==='function'){dialog.showModal();document.body.classList.add('locked');}
    else{dialog.setAttribute('open','');dialog.scrollIntoView({block:'center'});}
  }
  function closeDialog(dialog){
    if(typeof dialog.close==='function')dialog.close();else dialog.removeAttribute('open');
    document.body.classList.remove('locked');
    if(returnFocus&&returnFocus.focus)returnFocus.focus();
  }
  $$('.dialog').forEach(dialog=>{
    $$('[data-close]',dialog).forEach(b=>b.addEventListener('click',()=>closeDialog(dialog)));
    dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)closeDialog(dialog);}});
    dialog.addEventListener('close',()=>document.body.classList.remove('locked'));
  });
  function enquire(message){
    if(connected){window.open(waUrl(message),'_blank','noopener,noreferrer');return;}
    const dialog=$('#enquiry-dialog');
    $('#enquiry-message').value=message;
    $('#copy-status').textContent='';
    openDialog(dialog);
  }
  $$('[data-wa]').forEach(a=>{
    const message=a.dataset.message||defaultMessage;
    const recipient=a.dataset.wa==='backup'?backupNumber:number;
    const available=/^[1-9]\d{6,14}$/.test(recipient)&&recipient!=='15555550100';
    a.href=waUrl(message,recipient);a.target='_blank';a.rel='noopener noreferrer';
    a.addEventListener('click',e=>{if(!available){e.preventDefault();enquire(message);}});
  });
  const copy=$('#copy-enquiry');
  if(copy)copy.addEventListener('click',async()=>{
    const field=$('#enquiry-message'), status=$('#copy-status');
    try{await navigator.clipboard.writeText(field.value);status.textContent='Enquiry copied.';}
    catch(e){field.focus();field.select();try{status.textContent=document.execCommand('copy')?'Enquiry copied.':'Select the text above and copy it.';}catch(err){status.textContent='Select the text above and copy it.';}}
  });
  const menu=$('#menu-toggle'), nav=$('#main-nav');
  function closeMenu(focus){if(!menu||!nav)return;nav.classList.remove('is-open');menu.setAttribute('aria-expanded','false');menu.setAttribute('aria-label','Open menu');if(focus)menu.focus();}
  if(menu&&nav){
    menu.addEventListener('click',()=>{const open=menu.getAttribute('aria-expanded')!=='true';menu.setAttribute('aria-expanded',String(open));menu.setAttribute('aria-label',open?'Close menu':'Open menu');nav.classList.toggle('is-open',open);});
    document.addEventListener('keydown',e=>{if(e.key==='Escape'&&nav.classList.contains('is-open'))closeMenu(true);});
    document.addEventListener('click',e=>{if(!e.target.closest('.site-header'))closeMenu(false);});
    nav.addEventListener('click',e=>{if(e.target.closest('a'))closeMenu(false);});
    window.matchMedia('(min-width:1100px)').addEventListener('change',()=>closeMenu(false));
  }
  $$('[data-filter]').forEach(button=>button.addEventListener('click',()=>{
    const category=button.dataset.filter;
    $$('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
    let count=0;
    $$('[data-category]').forEach(card=>{card.hidden=category!=='all'&&card.dataset.category!==category;if(!card.hidden)count++;});
    const result=$('#filter-count');if(result)result.textContent=count+' designs';
  }));
  $$('[data-enquiry-form]').forEach(form=>form.addEventListener('submit',e=>{
    e.preventDefault();if(!form.reportValidity())return;
    const data=new FormData(form);
    const lines=[form.dataset.intro||"Hi SHAVERA, I'd like to discuss a custom piece."];
    for(const [key,value] of data.entries()){const v=String(value).trim();if(v)lines.push(key+': '+v);}
    lines.push('Please share stone details, available certification, a quote and estimated lead time.');
    enquire(lines.join('\n'));
  }));
  $$('[data-zoom]').forEach(button=>button.addEventListener('click',()=>{
    const dialog=$('#zoom-dialog'), image=$('#zoom-image');
    image.src=button.dataset.zoom;image.alt=button.querySelector('img').alt;
    openDialog(dialog);
  }));
  // Variant picker: live price + buy now for in-stock combinations
  const variantJson=$('[data-variant-json]');
  if(variantJson){
    const variants=JSON.parse(variantJson.textContent);
    const fields=$$('[data-option-field]');
    const panel=$('[data-buy-panel]'),priceEl=$('[data-buy-price]'),
          note=$('[data-stock-note]'),buyBtn=$('[data-buy-now]'),addBtn=$('[data-add-cart]');
    const fmt=variantJson.dataset.moneyFormat||'${{amount}}';
    const money=cents=>{
      const n=(cents/100).toFixed(2),parts=n.split('.');
      parts[0]=parts[0].replace(/\B(?=(\d{3})+(?!\d))/g,',');
      return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/,parts[0])
                .replace(/\{\{\s*amount\s*\}\}/,parts.join('.'));
    };
    const values=()=>fields.map(f=>{const b=f.querySelector('.option-btn[aria-pressed="true"]');return b?b.dataset.optionValue:'';});
    const matches=(v,vals)=>v.options.every((o,i)=>!vals[i]||vals[i]===o);
    const refresh=()=>{
      const vals=values();
      fields.forEach((f,i)=>{
        $$('.option-btn',f).forEach(btn=>{
          const test=vals.slice();test[i]=btn.dataset.optionValue;
          btn.disabled=!variants.some(v=>v.available&&matches(v,test));
        });
      });
      const complete=vals.every(v=>v);
      const exact=complete?variants.find(v=>matches(v,vals)):null;
      if(exact&&exact.available){
        let html='<span class="price-now">'+money(exact.price)+'</span>';
        if(exact.compare_at_price&&exact.compare_at_price>exact.price)
          html+=' <s class="price-was">'+money(exact.compare_at_price)+'</s>';
        priceEl.innerHTML=html;
        panel.hidden=false;note.hidden=true;
        buyBtn.dataset.variantId=exact.id;
        if(addBtn)addBtn.dataset.variantId=exact.id;
      }else{
        panel.hidden=true;note.hidden=!complete;
      }
    };
    fields.forEach(f=>{
      $$('.option-btn',f).forEach(btn=>btn.addEventListener('click',()=>{
        $$('.option-btn',f).forEach(b=>b.setAttribute('aria-pressed','false'));
        btn.setAttribute('aria-pressed','true');
        const label=f.querySelector('[data-option-selected]');
        if(label)label.textContent=btn.dataset.optionValue;
        refresh();
      }));
    });
    if(addBtn)addBtn.addEventListener('click',()=>addVariantToCart(addBtn.dataset.variantId,addBtn));
    buyBtn.addEventListener('click',()=>{
      const id=buyBtn.dataset.variantId;if(!id)return;
      buyBtn.disabled=true;
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({items:[{id:Number(id),quantity:1}]})})
        .then(r=>{if(!r.ok)throw new Error();window.location.assign('/checkout');})
        .catch(()=>{window.location.assign('/cart/'+id+':1');});
    });
    refresh();
  }
})();
